import { useEffect, useState, useRef } from "react";
import { message, Modal, Input, Row, Col } from "antd";
import "../style.css";
import { useHistory } from "react-router-dom";
import logo from "../../assets/images/cwsuite-logo.png";
import eye from "../../assets/images/eye.png";
import Loader from "./Loader"; // Assuming this is a custom component
import QRCodeSVG from "react-qr-code";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { getGlobalParameters, signIn, verifyOtpForLogin } from "../../services/generic";
import messages from "../../errors/messages.en-IN.json";

// SignIn Component
const SignIn = () => {
  const history = useHistory();
  const Instance = process.env.REACT_APP_INSTANCE_TYPE || "Enterprise";
  const domainURL = process.env.REACT_APP_domain;

  // Query params (simulating URLSearchParams instead of Next.js router)
  const queryParams = new URLSearchParams(window.location.search);

  const username = queryParams.get("username");
  const readOnly = queryParams.get("readOnly");

  const isReadOnly = readOnly === "true";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mfaModalVisible, setMfaModalVisible] = useState(false);
  const [mfaType, setMfaType] = useState("Email OTP");
  const [otpAuthUrl, setOtpAuthUrl] = useState(null);
  const [mfaUserActivityLogId, setMfaUserActivityLogId] = useState("");
  const inputsRef = useRef([]);
  const [otp, setOtp] = useState(Array(6).fill(""));

  useEffect(() => {
    setLoading(true);
    check();
  }, []);

  const check = async () => {
    const authHeaders = await getOAuthHeaders();
    if (authHeaders?.token && !username) {
      setLoading(false);
      history.push("/");
    } else {
      setEmail(username);
      setLoading(false);
    }
  };

  const getDataforEnterprise = async (data) => {
    let d = new Date();
    d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days from now
    let expires = "expires=" + d.toUTCString();
    let domain = "domain=" + domainURL;
    document.cookie = "userId=" + data.userId + ";" + "expires=0" + ";path=/;secure=true;SameSite=Strict;" + domain;
    document.cookie = "Enterprise.accessToken=" + data.accessToken + ";" + "expires=0" + ";path=/;secure=true;SameSite=Strict;" + domain;
    document.cookie = "accessToken=" + data.accessToken + ";" + "expires=0" + ";path=/;secure=true;SameSite=Strict;" + domain;
    document.cookie = "Enterprise.refreshToken=" + data.refreshToken + ";" + "expires=0" + ";path=/;secure=true;SameSite=Strict;" + domain;
    document.cookie = "Enterprise=" + true + ";" + "expires=0" + ";path=/;secure=true;SameSite=Strict;" + domain;
    document.cookie = "username=" + data.username + ";" + "expires=0" + ";path=/;secure=true;SameSite=Strict;" + domain;
    localStorage.setItem("refreshToken", data.refreshToken);

    let body2 = { token: data.accessToken };
    let body3 = { token: data.accessToken, id: null };

    try {
      var win2 = document.getElementById("myIframe2").contentWindow;
      var win3 = document.getElementById("myIframe3").contentWindow;
      const globalParametersResponse = await getGlobalParameters();

      if (globalParametersResponse.status === 200) {
        const parsedResponse = JSON.parse(globalParametersResponse.data.data.getGlobalParameters);
        localStorage.setItem("userData", JSON.stringify(parsedResponse.User));
        history.push("/");
      } else {
        setLoading(false);
        displayErrorMessage();
      }
    } catch (error) {
      if (error.message === "Request failed with status code 500") {
        setLoading(false);
        displayErrorMessage();
      }
    }
  };

  const displayErrorMessage = () => {
    message.error({
      content: (
        <div>
          <p>{messages.errors.authentication.session_data_error}</p>
        </div>
      ),
      duration: 10,
      style: { whiteSpace: "pre-wrap" },
    });
  };

  const handleLoginForEnterprise = async (event) => {
    event.preventDefault();
    if (!email || !password) {
      message.error(`${messages.errors.authentication.email_password_required}`);
      return;
    }
    setLoading(true);
    const payload = {
      username: email,
      password: password,
    };
    try {
      const res = await signIn(payload);
      if (res.status === 200) {
        const data = res.data;
        if (data.mfaRequired === "Y") {
          setMfaType(data.mfaType);
          setOtpAuthUrl(data.otpAuthUrl ?? null);
          setMfaUserActivityLogId(data.userActivityLogId);
          setMfaModalVisible(true);
          setLoading(false);
          return;
        }
        getDataforEnterprise(res.data);
      } else {
        setLoading(false);
        message.error(`${messages.errors.authentication.session_error}`);
      }
    } catch (error) {
      setLoading(false);
      message.error(`${messages.errors.authentication.invalid_credentials}`);
    }
  };

  const verifyOtp = async () => {
    const enteredOtp = otp.join("");
    if (!enteredOtp.trim()) {
      message.error("Please enter the OTP");
      return;
    }

    const payload = {
      username: email,
      userActivityLogId: mfaUserActivityLogId,
      otp: enteredOtp,
    };

    try {
      const res = await verifyOtpForLogin(payload);
      if (res.status === 200) {
        await getDataforEnterprise(res.data);
        setMfaModalVisible(false);
      } else {
        message.error("Invalid OTP");
      }
    } catch (error) {
      console.error(error);
      const msg = error.response?.data?.message || "OTP verification failed";
      message.error(msg);
    }
  };

  const handleChange = (val, index) => {
    const digit = val.replace(/\D/g, "").slice(0, 1); // allow only 1 digit

    const otpArray = [...otp];
    otpArray[index] = digit;
    setOtp(otpArray);

    // Move focus to next box if digit entered
    if (digit && index < otp.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        // clear current digit
        const otpArray = [...otp];
        otpArray[index] = "";
        setOtp(otpArray);
      } else if (index > 0) {
        // move focus back
        inputsRef.current[index - 1]?.focus();
      }
    }
  };

  const renderMfaModal = () => {
    const isGoogle = mfaType === "Google Authenticator";

    return (
      <Modal visible={mfaModalVisible} onCancel={() => setMfaModalVisible(false)} footer={null} width={380} centered bodyStyle={{ padding: "20px 25px" }}>
        <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 600, fontSize: "1.1em" }}>Multi-Factor Authentication</p>
        <div className="flex flex-col items-center space-y-4">
          {isGoogle && otpAuthUrl && (
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
              <div
                style={{
                  textAlign: "center",
                  marginTop: "2vh",
                  padding: "12px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                  display: "inline-block",
                }}
              >
                <QRCodeSVG value={otpAuthUrl} size={180} level="M" bgColor="#FFFFFF" fgColor="#000000" marginSize={0} />
              </div>
            </div>
          )}

          <p style={{ marginBottom: 0, marginTop: "1.5vh", textAlign: "center", fontSize: "0.9em", fontWeight: 500 }}>
            {isGoogle ? "Scan the QR code with Google Authenticator, then enter the 6-digit code." : "We have sent a 6-digit OTP to your email. Enter it below."}
          </p>

          <Row justify="center" gutter={[8, 8]} style={{ marginTop: "10px" }}>
            {otp.map((digit, idx) => (
              <Col key={idx}>
                <Input
                  value={digit}
                  maxLength={1}
                  ref={(el) => (inputsRef.current[idx] = el)}
                  onChange={(e) => handleChange(e.target.value, idx)}
                  onKeyDown={(e) => handleKeyDown(e, idx)}
                  style={{
                    width: "45px",
                    height: "33px",
                    textAlign: "center",
                    fontSize: "18px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    fontWeight: "500",
                  }}
                />
              </Col>
            ))}
          </Row>

          <button
            onClick={verifyOtp}
            style={{
              width: "100%",
              backgroundColor: "#91C507",
              marginTop: "2.2vh",
              color: "#fff",
              borderRadius: "3px",
              height: "6vh",
              border: "none",
              fontSize: "0.9em",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Verify OTP
          </button>
        </div>
      </Modal>
    );
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSignUp = () => {
    setLoading(true);
    window.location.href = "/sign-up"; // Replace Router.push with window.location.href
  };

  const handleForgotPassword = () => {
    setLoading(true);
    window.location.href = "/forgot-password"; // Replace Router.push with window.location.href
  };

  return (
    <>
      {renderMfaModal()}
      <section style={{ height: "100vh", width: "100%", backgroundColor: "#F3F4F9", padding: "2.5rem 0" }}>
        <div style={{ marginTop: "3rem", position: "relative", display: "grid" }}>
          <div
            className="loginDiv"
            style={{
              maxWidth: "27rem",
              margin: "0 auto",
              backgroundColor: "#F3F4F9",
              //   border: "1px solid #e2e2e2",
              //   padding: "20px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2.5rem" }}>
              {/* Replace next/image with standard img tag */}
              <img src={logo} alt="LOGO" style={{ height: "28px" }} />
            </div>
            <div style={{ maxWidth: "28rem", margin: "0 auto" }}>
              <form style={{ margin: "1rem 2.5rem 0" }} onSubmit={handleLoginForEnterprise}>
                <label style={{ fontFamily: "Inter", fontSize: "14px", opacity: 0.8, color: "#101828" }}>Username</label>
                <input
                  readOnly={isReadOnly}
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "0.25rem",
                    padding: "8px 12px",
                    color: "#101828",
                    border: "0.5px solid #DaDaDa",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    outline: "none",
                    marginBottom: "1rem",
                  }}
                  required
                  type="text"
                  placeholder="Enter Email"
                  value={email}
                  id="username"
                  name="username"
                  onChange={(ev) => setEmail(ev.target.value)}
                />
                <label style={{ fontFamily: "Inter", fontSize: "14px", opacity: 0.8, color: "#101828" }}>Password</label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    style={{
                      width: "100%",
                      height: "40px",
                      padding: "8px 12px",
                      border: "1px solid #dadada",
                      color: "#101828",
                      borderRadius: "4px",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      outline: "none",
                    }}
                    required
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={password}
                    onChange={(ev) => setPassword(ev.target.value)}
                  />
                  <img onClick={togglePasswordVisibility} style={{ marginLeft: "-36px", cursor: "pointer" }} src={eye} alt="Toggle password visibility" width={15} />
                </div>
                <button
                  id="login"
                  name="login"
                  onClick={handleLoginForEnterprise}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "50px",
                    margin: "20px 0 8px",
                    backgroundColor: "#91C507",
                    color: "#fff",
                    fontFamily: "Inter",
                    fontSize: "13px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                  }}
                >
                  Login
                </button>
              </form>
              <div
                style={{
                  margin: "8px 40px 28px",
                  display: Instance === "Enterprise" ? "none" : "grid",
                  gridTemplateColumns: "1fr 1fr",
                }}
              >
                <a onClick={handleSignUp} style={{ color: "#0500ED", fontFamily: "Inter", fontSize: "0.8rem", cursor: "pointer" }}>
                  Sign Up
                </a>
                <p
                  onClick={handleForgotPassword}
                  style={{
                    color: "#0500ED",
                    fontFamily: "Inter",
                    fontSize: "0.8rem",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  Forgot Password?
                </p>
              </div>
            </div>
          </div>
          {loading && (
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                // backgroundColor: "rgba(255, 255, 255, 0.87)",
                borderRadius: "12px",
              }}
            >
              <Loader />
            </div>
          )}
        </div>
      </section>

      {/* Hidden iframes for postMessage (if needed) */}
      <iframe id="myIframe2" style={{ display: "none" }} />
      <iframe id="myIframe3" style={{ display: "none" }} />
    </>
  );
};

export default SignIn;
